import { useReduxDispatch, useReduxSelector } from '../redux/hooks';
import { ChatApi } from '../redux/api/ChatApi';
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';
import { ensureUTCDate } from '../util/ChatUtils';

export default function UnreadMessageCount(props: { conversationUid: string, showLabel?: boolean, showZero?: boolean }) {
    const dispatch = useReduxDispatch();
    const { data: messages } = ChatApi.useGetMessagesQuery(props.conversationUid);
    const { data: chat } = ChatApi.useGetChatQuery(props.conversationUid);
    const { data: userProfile } = ChatApi.useGetProfileQuery();

    //count the number of unready messages by the other user
    const unreadMessages = messages?.filter(m => !m.Is_Event && m.Id !== 0 && new Date(ensureUTCDate(m.Created)) > (chat?.StaffContact_Id == userProfile?.Id ? new Date(ensureUTCDate(chat?.Staff_Last_Read) ?? 0) : new Date(ensureUTCDate(chat?.EndUser_Last_Read) ?? 0)));

    //console.log('UnreadMessageCount: ', props.conversationUid, unreadMessages?.length, messages?.length, chat?.StaffContact_Id == userProfile?.Id, ensureUTCDate(chat?.Staff_Last_Read));
    //console.log('found mesages:', messages?.filter(m => !m.Is_Event && m.Id !== 0 && new Date(ensureUTCDate(m.Created)) > new Date(ensureUTCDate(chat?.Staff_Last_Read) ?? 0)), new Date(ensureUTCDate(chat?.Staff_Last_Read) ?? 0).toISOString());

    if (props.showLabel == false)
        return <></>


    if (unreadMessages?.length || props.showZero)
        return (
            <BadgeContainer><Badge align={{ horizontal: 'start', vertical: 'top' }} position='outside' rounded={'full'}>{unreadMessages?.length || 0}</Badge></BadgeContainer>
        )
}
